import { render, staticRenderFns } from "./PromotorForm.vue?vue&type=template&id=11c5c79e"
import script from "./PromotorForm.vue?vue&type=script&lang=js"
export * from "./PromotorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports